export const defaultComponentSetting = {
    "device-login-info": {
        "label": "device_login_info",
        "type": "checkbox",
        "default-value": true,
        "class": null,
        "id": null,
        "options": {
            "is-mobile": true,
            "user-login": true,
            "payments": true
        }
    },
    "top-nav-logo": {
        "label": "top_user_logo",
        "type": "dropdown",
        "default-value": true,
        "class": null,
        "id": null,
        "options": [
            {
                "key": "show",
                "value": true
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "top-nav-menus": {
        "label": "top_user_menus",
        "type": "dropdown",
        "default-value": true,
        "class": null,
        "id": null,
        "options": [
            {
                "key": "show",
                "value": true
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "top-nav-login-box": {
        "label": "top_login_box",
        "type": "dropdown",
        "default-value": "popup",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Inline",
                "value": "inline"
            },
            {
                "key": "Popup",
                "value": "popup"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "top-nav-register-box": {
        "label": "top_register_box",
        "type": "dropdown",
        "default-value": "inline",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Inline",
                "value": "inline"
            },
            {
                "key": "Popup",
                "value": "popup"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "news": {
        "label": "news",
        "type": "dropdown",
        "default-value": false,
        "class": null,
        "id": null,
        "options": [
            {
                "key": "show",
                "value": true
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "nav-bar": {
        "label": "nav_bar",
        "type": "dropdown",
        "default-value": "horizonatal",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Horizonatal",
                "value": "horizonatal"
            },
            {
                "key": "Vertical",
                "value": "vertical"
            },
            {
                "key": "Nav Carozal",
                "value": "nav-carozal"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "horizonatal-nav-bar": {
        "label": "horizonatal_nav_bar",
        "type": "dropdown",
        "default-value": "menu-dropdown",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Label Icon",
                "value": "label-icon"
            },
            {
                "key": "Only Lable",
                "value": "only-lable"
            },
            {
                "key": "Hover Listing",
                "value": "hover-listing"
            },
            {
                "key": "Icon Toggel",
                "value": "icon-toggel"
            },
            {
                "key": "Menu Dropdown",
                "value": "menu-dropdown"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "vertical-nav-bar": {
        "label": "vertical_nav_bar",
        "type": "dropdown",
        "default-value": "left",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Left",
                "value": "left"
            },
            {
                "key": "Right",
                "value": "right"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "vertical_menu_listing": {
        "label": "dropdown_listing",
        "type": "dropdown",
        "default-value": "dropdown_listing",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Dropdown Listing",
                "value": "dropdown_listing"
            },
            {
                "key": "Menu Listing",
                "value": "menu_listing"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "search": {
        "label": "search",
        "type": "dropdown",
        "default-value": true,
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Show",
                "value": true
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "category-nav-bar": {
        "label": "vertical_category_nav_bar",
        "type": "dropdown",
        "default-value": "horizonatal",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Vertical",
                "value": "vertical"
            },
            {
                "key": "Horizonatal",
                "value": "horizonatal"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "category-vertical-nav-bar": {
        "label": "category_vertical_nav_bar",
        "type": "dropdown",
        "default-value": "label-icon",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Label Icon",
                "value": "label-icon"
            },
            {
                "key": "Only Label",
                "value": "only-label"
            }
        ]
    },
    "category-horizonatal-nav-bar": {
        "label": "category_horizonatal_nav_bar",
        "type": "dropdown",
        "default-value": "label-icon",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Label Icon",
                "value": "label-icon"
            },
            {
                "key": "Only Label",
                "value": "only-label"
            }
        ]
    },
    "floating-components": {
        "label": "floating_component",
        "type": "dropdown",
        "default-value": "right-vertical",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Right Vertical",
                "value": "right-vertical"
            },
            {
                "key": "Left Vertical",
                "value": "left-vertical"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "lottery-result-type": {
        "label": "lottery_result_type",
        "type": "dropdown",
        "default-value": "full-slider",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Grid",
                "value": "grid"
            },
            {
                "key": "Full Slider",
                "value": "full-slider"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "jackpot": {
        "label": "jackpot",
        "type": "dropdown",
        "default-value": "grid",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Grid",
                "value": "grid"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "gif-image": {
        "label": "gif_image",
        "type": "dropdown",
        "default-value": "grid",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Grid",
                "value": "grid"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "read-more": {
        "label": "read_more",
        "type": "dropdown",
        "default-value": "fixed",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Fixed",
                "value": "fixed"
            },
            {
                "key": "Popup",
                "value": "popup"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "payment-method": {
        "label": "payment_method",
        "type": "dropdown",
        "default-value": "payment-grid-full",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Full Width",
                "value": "payment-grid-full"
            },
            {
                "key": "Half Width",
                "value": "payment-grid-half"
            },
            {
                "key": "Slider",
                "value": "payment-slider"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "partners-logo": {
        "label": "partner_logo",
        "type": "dropdown",
        "default-value": "full-width",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Grid",
                "value": "grid"
            },
            {
                "key": "Slider",
                "value": "slider"
            },
            {
                "key": "Full Width",
                "value": "full-width"
            },
            {
                "key": "Half Width",
                "value": "half-width"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "social-media": {
        "label": "social_media",
        "type": "dropdown",
        "default-value": "social-media-static",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Fixed",
                "value": "social-media-static"
            },
            {
                "key": "Left",
                "value": "social-media-floating-left"
            },
            {
                "key": "Right",
                "value": "social-media-floating-right"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "popup": {
        "label": "popups",
        "type": "dropdown",
        "default-value": "middle",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Top",
                "value": "top"
            },
            {
                "key": "Middle",
                "value": "middle"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "slider": {
        "label": "slider",
        "type": "checkbox",
        "default-value": null,
        "class": null,
        "id": null,
        "options": {
            "slider": true,
            "dots": true,
            "arrows": true,
            "autoplay": true,
            "speed": "500",
            "infinite": true,
            "slidesToShow": "1",
            "slidesToScroll": "1",
            "visibility": true
        }
    },
    "hot-games": {
        "label": "hot_games",
        "type": "dropdown",
        "default-value": "hotgame-slider",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Grid",
                "value": "hotgame-grid"
            },
            {
                "key": "Slider",
                "value": "hotgame-slider"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "game-provider": {
        "label": "game_provider",
        "type": "dropdown",
        "default-value": "game-provider-carousel",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Grid",
                "value": "game-provider-grid"
            },
            {
                "key": "Carousel",
                "value": "game-provider-carousel"
            },
            {
                "key": "false",
                "value": false
            }
        ]
    },
    "provider-game": {
        "label": "provider_game",
        "type": "dropdown",
        "default-value": "provider-game-grid",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Grid",
                "value": "provider-game-grid"
            },
            {
                "key": "Carousel",
                "value": "provider-game-slider"
            },
            {
                "key": "false",
                "value": false
            }
        ]
    },
    "custom_loading": {
        "label": "custom_component_settings",
        "type": "checkbox",
        "default-value": null,
        "class": null,
        "id": null,
        "options": {
            "loading_component": true,
            "referral_navigation_handle": true,
            "outstanding_bet_handle": true,
            "header_handle": true,
            "profile_handle": true,
            "navbar_handle": false,
            "slider_handle": true,
            "common_section_handle": true,
            "payment_grid_handle": true,
            "game_category_handle": true,
            "provider_game_handle": true,
            "referral_tab": true,
            "game_provider_handle": true,
            "game_filter": true,
            "section_title": true,
            "footer_menu": true,
            "back_button": true,
            "common_payment": true,
            "notification_m": true,
            "remove_dropdown_sidebar": true,
            "menu_help": true,
            "hotnew_games_loadings": true
        }
    },
    "lottery_slider": {
        "label": "lottery_slider",
        "type": "checkbox",
        "default-value": true,
        "class": null,
        "id": null,
        "options": {
            "dots": true,
            "arrows": true,
            "autoplay": true,
            "speed": "50000",
            "infinite": true,
            "slides_toshow": "7",
            "slides_toscroll": "1",
            "visibility": true,
            "center_mode": true,
            "center_padding": "30px",
            "next_arrow": true,
            "prev_arrow": true
        }
    },
    "mobile_sidebar_menu_listing": {
        "label": "mobile_sidebar_menu_listing",
        "type": "dropdown",
        "default-value": "dropdown_listing",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "Dropdown Listing",
                "value": "dropdown_listing"
            },
            {
                "key": "Menu Listing",
                "value": "menu_listing"
            },
            {
                "key": "Hide",
                "value": false
            }
        ]
    },
    "Mobile Sidebar Menu Grid": {
        "label": "Mobile Sidebar Menu Grid",
        "type": "dropdown",
        "default-value": "hide",
        "class": null,
        "id": null,
        "options": [
            {
                "key": "show",
                "value": "show"
            },
            {
                "key": "hide",
                "value": "hide"
            }
        ]
    },
    "client_name": "demo7"
};